export default __webpack_public_path__ + "static/media/mot-safe.0f148175.png";